import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const Nav = styled(motion.nav)`
  position: relative;
  z-index: ${({ theme }) => theme.zIndex.overlay};
  margin-top: 40px;
`;

const NavLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
`;

const NavLink = styled(motion.a)`
  color: rgba(255, 255, 255, 0.9);
  margin: 0 8px;
  text-decoration: none;
  transition: ${({ theme }) => theme.transitions.default};
  padding: 8px 16px;
  border-radius: 20px;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  font-weight: 600;

  &:hover {
    color: white;
    background: rgba(125, 211, 252, 0.2);
    transform: translateY(-2px);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    margin: 4px;
    font-size: 14px;
  }
`;

const navigationItems = [
  { href: '#about', label: 'About' },
  { href: '#experience', label: 'Experience' },
  { href: '#education', label: 'Education' },
  { href: '#achievements', label: 'Achievements' },
  { href: '#contact', label: 'Contact' },
];

const Navigation: React.FC = () => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Nav
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.6 }}
    >
      <NavLinks>
        {navigationItems.map((item, index) => (
          <NavLink
            key={item.href}
            href={item.href}
            onClick={(e) => handleClick(e, item.href)}
            whileHover={{ y: -2 }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.8 + index * 0.1 }}
          >
            {item.label}
          </NavLink>
        ))}
      </NavLinks>
    </Nav>
  );
};

export default Navigation;